import React from "react";

const DashboardFooter: React.FC = () => {
  return (
    <footer className="dashboard-footer">
      <div className="footer-content">
        <div className="footer-left">
          <span>© 2026 KabelTelekom VPN</span>
        </div>
        <div className="footer-right">
          <span>Uptime: 99.99%</span>
          <span className="separator">|</span>
          <span>Latency: 12ms</span>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;